/** When your routing erp is too long, you can split it into small modules **/
export default [
    {
        path: 'e/p/p/detail',
        name: 'planingPolicyDetail',
        component: () => import('@/views/erp/planning/policy/detail.vue')
    }
]
    
